module.exports = __webpack_public_path__ + "media/Video 62.33ae6efe.mp4";